<route>
{
  "meta": {
    "customSite": true
  }
}
</route>
<template>
  <div class="my-0 mx-auto text-center">
    <h1>Welcome back</h1>
    <p class="max-w-md mx-auto">
      Sign in to find great articles, personalize your homepage, and follow
      authors and topics that you find insightful.
    </p>
    <button
      v-on:click="signInWithTwitter"
      class="bg-primaryLight text-black text-center p-4 text-xl"
    >
      Sign in with Twitter
    </button>
    <p class="mt-4 max-w-lg mx-auto">
      Click 'Sign In' to agree to provide feedback as well as agree to our
      <a href="/terms">terms of service</a> and
      <a href="/privacy">privacy policy</a>.
    </p>
  </div>
</template>

<script>
import store from '@/store';
import userInfo from '../../services/userInfo';
import firebase from '../../services/firebase';

export default {
  name: 'Loginf',
  store,
  props: { creator: Object },
  data() {
    return {};
  },
  methods: {
    signInWithTwitter() {
      firebase.loginWithTwitter(this);
    },
  },
  mounted() {
    this.$root.$emit('cool_event_name', this.creator);
    store.commit('toggleLoading', true);
    firebase
      .getLoginResult(this)
      .then(
        async ({
          userId,
          userName,
          acctUsername,
          userEmail,
          description,
          isNewUser,
          profilePic,
          emailVerified,
          token,
          secret,
          providerId,
        }) => {
          store.commit('toggleLoading', false);
          console.log(isNewUser);
          if (isNewUser) {
            await userInfo.createNewUser(
              userId,
              userName,
              acctUsername,
              description,
              userEmail,
              profilePic,
              token,
              secret,
              providerId,
            );
          } else {
            await userInfo.updateUser(
              userId,
              userName,
              acctUsername,
              description,
              userEmail,
              profilePic,
              token,
              secret,
              providerId,
            );
          }
          const userdata = await userInfo.getUserInfo(userId);
          console.log(' >>>>>> ', userdata);
          await store.commit('setSignedIn', {
            user: {
              email: userdata.user.userEmail,
              name: userdata.user.userName,
              uid: userId,
              isVerified: emailVerified,
              profilePic: userdata.user.profilePic,
            },
            token,
          });
          const redirectPath = localStorage.getItem('redirectPath');
          if (redirectPath) {
            this.$router.push(redirectPath);
            localStorage.removeItem('redirectPath');
          } else {
            this.$router.push('/home');
          }
        },
      )
      .catch((err) => {
        store.commit('toggleLoading', false);
        console.log(err);
      });
  },
};
</script>
